import { View } from 'react-native';

import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';
import { graphql as tadaGraphql } from '@savvy/deprecated-shared/gql-compat';
import { useRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { useMutationWithErrorLogging } from '@savvy/deprecated-shared/hooks/useMutationWithErrorLogging';
import { isSavvyTestUserEmail } from '@savvy/deprecated-shared/utils/internal-savvy';
import { XLink } from '@savvy/deprecated-shared/x-components/x-link';
import { XTypography } from '@savvy/deprecated-shared/x-components/x-typography';

const XResetClientIntakeDataFooterButtonMutation = tadaGraphql(/* GraphQL */ `
  mutation XResetClientIntakeDataFooterButton($input: ResetClientIntakeDataInput!) {
    resetClientIntakeData(input: $input) {
      clientIntakeData {
        id
        intakeData
      }
    }
  }
`);

type Props = {
  readonly user: JWTContextUser | null;
};

export function XResetClientIntakeDataFooterButton({ user }: Props) {
  const router = useRouter();

  const [resetClientIntakeData] = useMutationWithErrorLogging(XResetClientIntakeDataFooterButtonMutation);

  if (process.env['NODE_ENV'] === 'production' && !isSavvyTestUserEmail(user ? user.email : null)) {
    return null;
  }

  return (
    <>
      <View style={{ paddingHorizontal: 2, paddingBottom: 3 }}>
        <XLink
          href="#"
          onClick={() => {
            void resetClientIntakeData({
              variables: {
                input: {},
              },
            });
            router.webOnlyReloadPage();
          }}
          underline="none"
        >
          <XTypography variant="caption" color="textSecondary">
            Reset Intake Data
          </XTypography>
        </XLink>
      </View>
      <View style={{ paddingHorizontal: 2 }}>
        <XTypography variant="caption" color="textSecondary">
          •
        </XTypography>
      </View>
    </>
  );
}
